export default "__VITE_ASSET__BumPAQbV__"